import React from "react";
import styles from "./ClientOrderCard.module.scss";
import {calculateTotal} from "../../../utils";
import moment from "moment";
import Button, {ButtonColors, ButtonSizes} from "../../Button/Button";
import Card from "../../Card/Card";
import {ReactComponent as ClockIcon} from "../../../assets/icons/time.svg";
import {ReactComponent as CalendarIcon} from "../../../assets/icons/date.svg";
import {ReactComponent as ArrowRightIcon} from "../../../assets/icons/right.svg";
import {useTranslation} from "react-i18next";
import Status, {StatusTypes} from "../../Status/Status";

const OrderStatusTypes = {
    APPROVED: StatusTypes.APPROVED,
    DECLINED: StatusTypes.REJECTED,
    SENT: StatusTypes.PENDING
}

const ClientOrderCard = ({order, onDetailsButtonClick}) => {

    const {t, i18n} = useTranslation();

    return (
        <Card className="mb-12" onClick={onDetailsButtonClick}>
            <div className={styles.top}>
                <div>
                    <p className={styles.subtitle}>
                        #{order.orderNumber.substr(order.orderNumber.length - 5)}
                    </p>
                    <div className="d-flex">
                        <p className={styles.title}>
                            <CalendarIcon className="mr-2"/> {moment.utc(order.createdDateTime).local().format("DD/MM/YYYY")}
                        </p>
                        <p className={styles.title}>
                            <ClockIcon className="mr-2"/> {moment.utc(order.createdDateTime).local().format("hh:mm")}
                        </p>
                    </div>
                </div>
                <div>
                    <p className={styles.subtitle}>
                        {t("Total")}
                    </p>
                    <p className={styles.title}>
                        {calculateTotal(order)}€
                    </p>
                </div>
            </div>
            <div className={styles.bottom}>
                <Button
                    className={styles.detailsButton}
                    size={ButtonSizes.Small}
                    color={ButtonColors.White}>
                    <ArrowRightIcon/> {t("See details")}
                </Button>
                <Status type={OrderStatusTypes[order.status]} />
            </div>
        </Card>
    )

}

export default ClientOrderCard;
